import React from 'react';
import { AppShell } from '@/components/AppShell';
import { Card, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { useAuth } from '@/context/AuthContext';
import { useNavigate } from 'react-router-dom';
import { TRACK_LABELS } from '@/lib/tracks';
import { LogOut, User } from 'lucide-react';

export default function ProfilePage() {
  const { user, logout } = useAuth();
  const nav = useNavigate();

  return (
    <AppShell>
      <div className="space-y-5" data-testid="profile-page">
        <div className="flex items-center gap-2">
          <User className="h-5 w-5" />
          <h1 className="font-display text-2xl font-semibold">Your profile</h1>
        </div>
        <Card>
          <CardContent className="space-y-3 p-6">
            <Row label="Name" value={user?.name} />
            <Row label="Email" value={user?.email} />
            <Row label="Class" value={user?.class_pref ? `Class ${user.class_pref}` : 'Not set'} />
            <Row label="Track" value={user?.track_pref ? TRACK_LABELS[user.track_pref] : 'Not set'} />
            <Row label="Joined" value={user?.created_at ? new Date(user.created_at).toLocaleString() : '—'} />
          </CardContent>
        </Card>
        <Button
          variant="destructive"
          className="gap-1.5"
          onClick={() => {
            logout();
            nav('/login');
          }}
          data-testid="profile-logout-button"
        >
          <LogOut className="h-4 w-4" />
          Log out
        </Button>
      </div>
    </AppShell>
  );
}

function Row({ label, value }) {
  return (
    <div className="flex items-center justify-between border-b py-2 last:border-b-0">
      <div className="text-sm text-muted-foreground">{label}</div>
      <Badge variant="secondary" className="font-normal">{value || '—'}</Badge>
    </div>
  );
}
